<!--报价标书-->
<template>
  <div class="bidding-document-container">
    <header-index/>
    <div class="bidding-document-content" :style="'min-height:'+min_height+'px;'">
      <!--面包削-切换导航栏-->
      <div class="bidding-document-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: '/outsourceDemand/index' }">交易大厅</el-breadcrumb-item>
          <el-breadcrumb-item><a @click="goBack">投标详情</a></el-breadcrumb-item>
          <el-breadcrumb-item>报价标书</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="bidding-document-details">
        <el-row :gutter="16">
          <el-col :span="18">
            <div class="bidding-document-left">
              <div class="bidding-descriptions">
                <el-descriptions :column="1">
                  <el-descriptions-item label="报价金额">
                    <span class="descriptions-text-red">￥{{biddingTendersDetail.money}}{{biddingTendersDetail.moneyUnit}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="预计工期">
                    <span class="descriptions-text-red">{{biddingTendersDetail.duration}}天</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="联系电话">
                    <span class="descriptions-text">{{biddingTendersDetail.mobile}}</span>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
              <div class="bidding-details">
                <p class="demand-title">方案说明</p>
                <div class="details-info" v-html="biddingTendersDetail.content"/>
                <template v-if="biddingTendersDetail.appendix!==undefined && biddingTendersDetail.appendix!==null && biddingTendersDetail.appendix.length>0">
                  <p class="demand-title">附件</p>
                  <p v-for="bid of biddingTendersDetail.appendix" class="appendix" @click="handlePictureCardPreview(bid.url)">
                    <i class="iconfont icon-tupian"/>
                    <span>{{ bid.name }}</span>
                  </p>
                </template>
              </div>
              <div class="bidding-time">
                报价：<span>{{biddingTendersDetail.time}}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="release-demand" @click="releaseDemand"></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="20%" class="dialog">
      <p>您还未认证企业，暂无法发布需求。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="certifiedEnterprise">认证企业</el-button>
         <el-button @click="dialogVisible=false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="图片预览" width="550px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {biddingTendersDetails} from '@/api/cloudServiceApi'

export default {
  name: "bidingDoc",
  components: {headerIndex, home_footer, Hang},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 315,
      biddingTendersDetail: {},
      personalInfo:{},
      dialogVisible:false,
      dialogVisible2:false,
      dialogImageUrl:'',
      cid: 0,
      zid: 0,
      tid: 0,
    }
  },
  methods: {
    /*返回到指定页面*/
    goBack() {
      this.$router.back(-1);
    },
    /*获取投标书详情*/
    getBiddingTendersDetail() {
      biddingTendersDetails({
        tid: this.tid,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          this.biddingTendersDetail=res.content;
        }
      })
    },
    /**
     * @event 发布需求
     * @param verified_type 认证类型（1：个人，2：政府，3：企业，4：媒体，5：其他）
     * @param state 认证状态（1：已认证。0未认证,2:审核中，-1：认证失败）
     */
    releaseDemand() {
      if (this.personalInfo.verified_type == 3 && this.personalInfo.state == 1) {
        this.$router.push({path: '/outsourceDemand/releaseDemand',})
      } else {
        this.dialogVisible = true;
      }
    },
    /*认证企业*/
    certifiedEnterprise() {

    },
    /*判断文件类型*/
    matchFileType(fileName) {
      // 后缀获取
      let suffix = '';
      // 获取类型结果
      let result = '';
      if (!fileName) return false;
      try {
        // 截取文件后缀
        suffix = fileName.substr(fileName.lastIndexOf('.') + 1, fileName.length)
        // 文件后缀转小写，方便匹配
        suffix = suffix.toLowerCase()
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false;
        return result;
      }
      let fileTypeList = [
        // 图片类型
        {'typeName': 'image', 'types': ['png', 'jpg', 'jpeg', 'bmp', 'gif']},
        // 文本类型
        {'typeName': 'txt', 'types': ['txt']},
        // excel类型
        {'typeName': 'excel', 'types': ['xls', 'xlsx']},
        {'typeName': 'word', 'types': ['doc', 'docx']},
        {'typeName': 'pdf', 'types': ['pdf']},
        {'typeName': 'ppt', 'types': ['ppt']},
        // 视频类型
        {'typeName': 'video', 'types': ['mp4', 'm2v', 'mkv']},
      ]
      for (let i = 0; i < fileTypeList.length; i++) {
        const fileTypeItem = fileTypeList[i]
        const typeName = fileTypeItem.typeName
        const types = fileTypeItem.types;
        result = types.some(function (item) {
          return item === suffix;
        });
        if (result) {
          return typeName
        }
      }
      return 'other'
    },
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible2 = true;
    },
  },
  mounted() {
    this.getBiddingTendersDetail();
  },
  beforeMount() {
    this.zid = this.$route.query.zid;
    this.tid = this.$route.query.tid;
    this.personalInfo = sessionStorage.getItem('personalInfo') != null && sessionStorage.getItem('personalInfo') != undefined && sessionStorage.getItem('personalInfo') != '' ? JSON.parse(sessionStorage.getItem('personalInfo')) : '';
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>
<style scoped>
.bidding-document-container >>> .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: bold;
  color: #5D5D5D;
}
.bidding-document-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.bidding-document-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.bidding-document-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.bidding-document-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
.bidding-document-container >>> .bidding-document-content .bidding-document-details .bidding-document-left .el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 60px;
  min-width: 60px;
  justify-content: end;
}
.bidding-document-container >>> .bidding-document-content .bidding-document-details .bidding-document-left .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
  font-family: 'SourceHanSansCN';
  font-weight: 100;
  color: #333333;
  font-size: 14px;
  padding-bottom: 20px;
  line-height: normal;
}
</style>
<style scoped lang="scss">
.bidding-document-container {
  background: #F5F5F5;
  .bidding-document-content {
    padding: 20px 18%;
    .bidding-document-details{
      margin-top: 20px;
      .release-demand {
        background: url("~@/assets/img/cloud/releaseDemand.png") no-repeat;
        background-size: 100% 100%;
        height: 170px;
        cursor: pointer;
      }
      .bidding-document-left{
        background: #ffffff;
        padding: 30px;
        .bidding-descriptions{
          border-bottom: 1px solid #EDEDED;
          .descriptions-text-red{
            font-size: 14px;
            color: #FE273B;
            display: flex;
            min-width: 120px;
          }
          .descriptions-text{
            font-size: 14px;
            color: #333333;
            display: flex;
            min-width: 120px;
          }
        }
        .bidding-details{
          padding: 30px 0px;
          border-bottom: 1px solid #EDEDED;
          .demand-title {
            margin-block-start: 0em;
            margin-block-end: 0em;
            margin-bottom: 10px;
            border-left: 3px solid #FE273B;
            padding-left: 15px;
            font-size: 16px;
            color: #333333;
            display: flex;
            font-family: SourceHanSansCN;
            cursor: pointer;
          }
          .details-info {
            color: rgba(51, 51, 51, 0.76);
            line-height: 28px;
            font-size: 14px;
            padding: 0px 40px 0px 0px;
            cursor: pointer;
            margin-bottom: 30px;
          }
          .appendix {
            font-size: 14px;
            margin-block-start: 0px;
            margin-block-end: 0px;
            padding: 10px 20px 10px 10px;
            background: #F5F5F5;
            width: fit-content;
            margin-bottom: 10px;
            cursor: pointer;

            .iconfont {
              padding-right: 10px;
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .bidding-time{
          padding: 30px 0px;
          font-size: 12px;
          font-family: 'SourceHanSansCN';
          color: #333333;
          line-height: 18px;
          opacity: 0.76;
        }
      }
    }
  }
}
</style>